import React, { useState, useEffect, useRef } from 'react';


function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

function Counter() {
  const [count, setCount] = useState(10);
  const prevCount = usePrevious(count);


  const calculation = count + 100;
  const prevCalculation = usePrevious(calculation);


  return (
    <>
      <h1>Now: {count}, before: {prevCount}</h1>

      <h1>calculation: {calculation}, prevCalculation: {prevCalculation}</h1>


    </>

  );
}

export default Counter;
